import Thanks from '../../models/Thanks.js';

import {validation} from '../../static/js/settingFile/validationData.js';

export default class ThanksControllerAPI {

    static index(input){
        return new Promise(function(resolve,reject){

            if(input === undefined){
                Thanks.getAllThanksOrderByDate()
                .then(function(result){
                    resolve(result);
                })
                .catch(function(error){
                    reject(error);
                });
            }else if(input.member_id !== undefined) {
                //任意のメンバーのありがとを取得
                Thanks.getThanksByMember(input.member_id)
                .then(function(result){
                    resolve(result);
                })
                .catch(function(error){
                    reject(error);
                });
            }else if(input.sortObj !== undefined){
                //条件絞り込み
                Thanks.getSortedThanks(input.sortObj)
                .then(function(result){
                    resolve(result);
                })
                .catch(function(error){
                    reject(error);
                });
            }else if(input === 'yearList'){
                //年のリストを取得
                Thanks.getYearList()
                .then(function(result){
                    resolve(result);
                })
                .catch(function(error){
                    reject(error);
                });
            }

        })
    }

    static show(id){
        return new Promise(function(resolve,reject){
            
            Thanks.getSpecificThank(id)
            .then(function(result){
                resolve(result);
            })
            .catch(function(error){
                reject(error);
            });
        })
    }

    static store(newThanksData){

        return new Promise(function(resolve,reject){

            //タイトルチェック
            if(newThanksData.title.length > validation.thanksTitleMax){
                //通すけど、制限で切る
                newThanksData.title = newThanksData.title.substr(0,validation.thanksTitleMax);
            }
            
            //タイトルなしはダメ
            if(newThanksData.title.length === 0){
                reject({
                    status:false,
                    message:'titleError'
                });

                return;
            }

            //メモチェック
            if(newThanksData.memo.length > validation.thanksMemoMax){
                reject({
                    status:false,
                    message:'memoLengthOver'
                });

                return;
            }

            if(typeof newThanksData.member_id === 'undefined'){
                //undefinedで入ってきてしまっていたら、nullに直す。
                //フロントでもチェックはしているが、ここでも
                newThanksData.member_id = null;
            }

            Thanks.postThank(newThanksData)
            .then(function(result){
                resolve(result);
            })
            .catch(function(error){
                reject(error);
            })
        })
        
    }

    static delete(id) {
        return new Promise(function(resolve,reject){
            if(id === undefined){
                reject({
                    status:false,
                    message:'no ID'
                });
            }
            Thanks.deleteMember(id)
            .then(function(result){
                resolve(result);
            })
            .catch(function(error){
                reject(error);
            })
        })
    }




}
